import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { ReadOnlyFormControl } from 'components/common/fields';
import { memo } from 'react';
import { getUserIdWithFallback } from 'util/getUserId';

const OntracUserId = ({ transaction }) => {
  const userId = getUserIdWithFallback(
    transaction.updUserId,
    transaction.insUserId
  );

  return (
    <Grid item xs={2}>
      <ReadOnlyFormControl label="Ontrac User ID" value={userId} />
    </Grid>
  );
};

OntracUserId.propTypes = {
  transaction: PropTypes.object.isRequired,
};

export default memo(OntracUserId);
